<template>
  <intro-template
    @start="next"
    :requirements="true"
    button-label="Commencer">
    <template v-slot:module-title>
      Préparer le planning des semaines à venir
    </template>
    <template v-slot:requirements>
      <p><strong>Savoir déclarer une absence</strong> (module 1) <strong>et déclarer du temps supplémentaire</strong> (module 2)</p>
    </template>
    <template v-slot:learnings-title>
      Dans ce module, vous allez apprendre à...
    </template>
    <template v-slot:learnings>
      <p>Lire un planning GTA complet</p>
    </template>
    <template v-slot:rules>
      <div class="rule">
        <p class="label">
          Arbitrez
        </p>
        <p class="value">
          entre plusieurs plannings
        </p>
      </div>
    </template>
  </intro-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'Intro',
  mixins: [stepMixin]
}
</script>
